import { createSlice } from '@reduxjs/toolkit';
import { SkillState } from './skill.Type';
import { createSkill , UpdateSkills ,deleteSkill , fetchALlSkill  } from './skill.Action';



const initialState : SkillState = { 
    skill : [],
    selectedskill : undefined,
    loadingStates : {
        create: false,
        update: false,
        delete: false,
        fetchById: false,
        fetchAll: false,
    },
    errors: {
        create: undefined,
        update: undefined,
        delete: undefined,
        fetchById: undefined,
        fetchAll: undefined,
    },
}



const skillSlice = createSlice({
    name : 'skill',
    initialState,
    reducers:{},
    extraReducers : (builder) =>{
        builder 
          .addCase(createSkill.pending, (state) => {
                         state.loadingStates.create = true;
                         state.errors.create = undefined;
                     })
                     .addCase(createSkill.fulfilled, (state, action) => {
                         state.loadingStates.create = false;
                         state.skill.push(action.payload);
                     })
                     .addCase(createSkill.rejected, (state, action) => {
                         state.loadingStates.create = false;
                         state.errors.create = action.payload as string;
                     })
         
                     // Update 
                     .addCase(UpdateSkills.pending, (state) => {
                         state.loadingStates.update = true;
                         state.errors.update = undefined;
                     })
                     .addCase(UpdateSkills.fulfilled, (state, action) => {
                         state.loadingStates.update = false;
                         const index = state.skill.findIndex((d : any) => d.Id === action.payload.Id);
                         if (index !== -1) {
                             state.skill[index] = action.payload;
                         }
                     })
                     .addCase(UpdateSkills.rejected, (state, action) => {
                         state.loadingStates.update = false;
                         state.errors.update = action.payload as string;
                     })
         
                     // Delete 
                     .addCase(deleteSkill.pending, (state) => {
                         state.loadingStates.delete = true;
                         state.errors.delete = undefined;
                     })
                     .addCase(deleteSkill.fulfilled, (state, action) => {
                         state.loadingStates.delete = false;
                         state.skill = state.skill.filter((d : any) => d.Id !== action.payload);
                     })
                     .addCase(deleteSkill.rejected, (state, action) => {
                         state.loadingStates.delete = false;
                         state.errors.delete = action.payload as string;
                     })
         
                    //  // Fetch  by ID
                    //  .addCase(fetchResignationById.pending, (state) => {
                    //      state.loadingStates.fetchById = true;
                    //      state.errors.fetchById = undefined;
                    //  })
                    //  .addCase(fetchResignationById.fulfilled, (state, action) => {
                    //      state.loadingStates.fetchById = false;
                    //      state.selectedResignation = action.payload;
                    //  })
                    //  .addCase(fetchResignationById.rejected, (state, action) => {
                    //      state.loadingStates.fetchById = false;
                    //      state.errors.fetchById = action.payload as string;
                    //  })
         
                     // Fetch All 
                     .addCase(fetchALlSkill.pending, (state) => {
                         state.loadingStates.fetchAll = true;
                         state.errors.fetchAll = undefined;
                     })
                     .addCase(fetchALlSkill.fulfilled, (state, action) => {
                         state.loadingStates.fetchAll = false;
                         state.skill = action.payload.data;
                     })
                     .addCase(fetchALlSkill.rejected, (state, action) => {
                         state.loadingStates.fetchAll = false;
                         state.errors.fetchAll = action.payload as string;
                     }); 
    }
})

export default skillSlice.reducer;